import { render, staticRenderFns } from "./SectionMeta.vue?vue&type=template&id=30c4b9e7"
import script from "./SectionMeta.vue?vue&type=script&lang=js"
export * from "./SectionMeta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports